import { render } from "./words.vue?vue&type=template&id=dfa99d56&scoped=true&ts=true"
import script from "./words.vue?vue&type=script&lang=ts"
export * from "./words.vue?vue&type=script&lang=ts"

import "./style/index.scss?vue&type=style&index=0&id=dfa99d56&lang=scss&scoped=true"

import exportComponent from "/Users/ls/Documents/维思英才/webchat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfa99d56"]])

export default __exports__